.yearGrid {
  .option {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    border-radius: var(--ixf-border-radius-1);

    &.isActive {
      background: var(--ixf-text-tone-md);
    }
  }
}
